import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { ValidationDisplay, required, minLength, maxLength } from '@gig/magic-form-builder';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';

var countryState = [
    { StateName: 'Alabama', StateAbbreviation: 'AL' },
    { StateName: 'Alaska', StateAbbreviation: 'AK' },
    { StateName: 'Arizona', StateAbbreviation: 'AZ' },
    { StateName: 'Arkansas', StateAbbreviation: 'AR' },
    { StateName: 'California', StateAbbreviation: 'CA' },
    { StateName: 'Colorado', StateAbbreviation: 'CO' },
    { StateName: 'Delaware', StateAbbreviation: 'DE' },
    { StateName: 'Florida', StateAbbreviation: 'FL' },
    { StateName: 'Georgia', StateAbbreviation: 'GA' },
    { StateName: 'Hawaii', StateAbbreviation: 'HI' },
    { StateName: 'Illinois', StateAbbreviation: 'IL' },
    { StateName: 'Indiana', StateAbbreviation: 'IN' },
    { StateName: 'Iowa', StateAbbreviation: 'IA' },
    { StateName: 'Kansas', StateAbbreviation: 'KS' },
    { StateName: 'Kentucky', StateAbbreviation: 'KY' },
    { StateName: 'Louisiana', StateAbbreviation: 'LA' },
    { StateName: 'Maine', StateAbbreviation: 'ME' },
    { StateName: 'Maryland', StateAbbreviation: 'MD' },
    { StateName: 'Minnesota', StateAbbreviation: 'MN' },
    { StateName: 'Mississippi', StateAbbreviation: 'MS' },
    { StateName: 'Missouri', StateAbbreviation: 'MO' },
    { StateName: 'Montana', StateAbbreviation: 'MT' },
    { StateName: 'Nebraska', StateAbbreviation: 'NE' },
    { StateName: 'New Hampshire', StateAbbreviation: 'NH' },
    { StateName: 'New Mexico', StateAbbreviation: 'NM' },
    { StateName: 'New York', StateAbbreviation: 'NY' },
    { StateName: 'North Carolina', StateAbbreviation: 'NC' },
    { StateName: 'North Dakota', StateAbbreviation: 'ND' },
    { StateName: 'Ohio', StateAbbreviation: 'OH' },
    { StateName: 'Oklahoma', StateAbbreviation: 'OK' },
    { StateName: 'Oregon', StateAbbreviation: 'OR' },
    { StateName: 'Pennsylvania', StateAbbreviation: 'PA' },
    { StateName: 'Rhode Island', StateAbbreviation: 'RI' },
    { StateName: 'South Carolina', StateAbbreviation: 'SC' },
    { StateName: 'South Dakota', StateAbbreviation: 'SD' },
    { StateName: 'Tennessee', StateAbbreviation: 'TN' },
    { StateName: 'Texas', StateAbbreviation: 'TX' },
    { StateName: 'Utah', StateAbbreviation: 'UT' },
    { StateName: 'Vermont', StateAbbreviation: 'VT' },
    { StateName: 'Virginia', StateAbbreviation: 'VA' },
    { StateName: 'Washington', StateAbbreviation: 'WA' },
    { StateName: 'Wisconsin', StateAbbreviation: 'WI' },
    { StateName: 'Wyoming', StateAbbreviation: 'WY' },
];
function state() {
    var _this = this;
    return {
        id: 'state-wrapper',
        component: 'magic-ui-form-field',
        validationBase: 'state',
        isDataField: false,
        testId: 'step1-state',
        children: [
            {
                id: 'state',
                component: 'magic-ui-dropdown',
                isDataField: true,
                properties: {
                    placeholder: translate('sweepstakes.state.placeholder'),
                },
                validationDisplay: ValidationDisplay.OnTouchShowMessage,
                validation: [
                    {
                        name: 'required',
                        fn: required,
                        message: translate('sweepstakes.state.required-error'),
                    },
                    {
                        name: 'min-length',
                        fn: minLength(2),
                        message: translate('sweepstakes.state.min-length-error'),
                    },
                    {
                        name: 'max-length',
                        fn: maxLength(30),
                        message: translate('sweepstakes.state.max-length-error'),
                    },
                ],
                preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
                    var options;
                    return __generator(this, function (_a) {
                        options = countryState.map(function (state) { return ({
                            name: state.StateName,
                            value: state.StateAbbreviation,
                        }); });
                        return [2 /*return*/, { options: options }];
                    });
                }); },
                converter: function (formValue) {
                    return {
                        addressRegion: formValue.state.value,
                        addrCountryCode: Country.UNITED_STATES,
                    };
                },
            },
        ],
    };
}

export { state };
